import { Controller } from '@hotwired/stimulus'

// Reports foreground state + active chat so the server can skip OS push alerts.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }
  }

  connect () {
    this.ping()
    this.timer = window.setInterval(() => this.ping(), this.intervalValue)

    this.onVisibility = () => this.ping()
    this.onTurboLoad = () => this.ping()
    document.addEventListener('visibilitychange', this.onVisibility)
    document.addEventListener('turbo:load', this.onTurboLoad)
  }

  disconnect () {
    if (this.timer) window.clearInterval(this.timer)
    document.removeEventListener('visibilitychange', this.onVisibility)
    document.removeEventListener('turbo:load', this.onTurboLoad)
  }

  activeConversationId () {
    return document.querySelector('[data-chat-conversation-id]')?.dataset.chatConversationId || ''
  }

  csrfToken () {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }

  async ping () {
    if (!this.hasUrlValue) return

    const body = {
      visible: document.visibilityState === 'visible',
      path: window.location.pathname + window.location.search,
      conversation_id: this.activeConversationId() || null
    }

    try {
      await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': this.csrfToken()
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
        keepalive: true
      })
    } catch (_error) {
      // Ignore - next heartbeat retries.
    }
  }
}
